<!--
    本组件适用于全局参数设置
    声明参数 -> 参数暴露
-->
<script>
    import sa from 'sa-sdk-javascript'

    var token = '',//登录状态token
        title = 'a',
        a = true;
    var baseUrl = process.env.BASE_URL,//a ? 'https://act-test.huazhen.com/m' : 'https://act.huazhen.com/m',//请求地址
        appBaseUrl = process.env.APP_BASE_URL,//a? 'https://testing.huazhen.com':'https://www.huazhen.com',
        updateUrl = 'https://act.huazhen.com/api/view_webhook',
        column_compence = false,
        getValue = (key) => {
            var search = location.search.slice(1); //得到get方式提交的查询字符串
            var arr = search.split("&");
            for (var i = 0; i < arr.length; i++) {
                var ar = arr[i].split("=");
                if (ar[0] == key) {
                    return ar[1];
                }
            }
        },
        setCookie = (c_name, value, expiredays) => {
            var date = new Date();
            date.setTime(date.getTime() + expiredays);
            var expires = "; expires=" + date.toGMTString();
            var path = "; path=/";
            var domain = ";domain=.huazhen2008.com"
            var ddd = c_name + "=" + value + expires + domain + path;
            console.log('domain' + ddd);
            document.cookie = ddd;
        },
        getCookie = (name) => {
            var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (arr = document.cookie.match(reg))
                return (arr[2]);
            else
                return '';
        };
    export default {
        token,
        title,
        baseUrl,
        appBaseUrl,
        updateUrl,
        column_compence,
        getValue,
        sa,
        setCookie,
        getCookie,
    }

</script>



// WEBPACK FOOTER //
// src/components/global.vue